import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: `Do you have many students from Waterford?`,
  answer: `Yes! Because of our convenient location in Farmington Hills, we have many families from Waterford who train with us regularly.`
}, {
  question: 'How does the free one-week trial work?',
  answer: "Simply fill out the form, and we'll contact you to schedule your first visit. You'll get to try our classes for a full week with no obligation to join."
}, {
  question: 'Does my child need experience?',
  answer: 'Not at all! The vast majority of our new students have no prior martial arts experience. Our beginner classes are designed to teach the fundamentals from day one.'
}, {
  question: 'Do parents need to buy gear before the trial?',
  answer: 'No gear is needed to start. Just wear comfortable athletic clothing for your trial classes.'
}];
export function WaterfordFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-3524" />;
}